import api from '@/libs/axios'
import { cleanEntityToSend } from '../../utils/form'
import Vue from 'vue'
import ToastificationContent from '@/components/toastification/ToastificationContent.vue'
import { capitalize } from '@/utils/filter'
import i18n from '@/libs/i18n'
import store from '../index'
import useAppConfig from '../../utils/useAppConfig'
import useAPI from '../../utils/useAPI'
import qs from 'qs'
import { getUserData } from '../../utils/utils'

export default {
  // Payload : page, perPage, searchCriteria, sortColumn, sortOrder
  getModuleViews ({ commit, state }, payload = {}) {
    store.commit('app/TOGGLE_LOADING', true)

    return new Promise((resolve, reject) => {
      // console.log(payload)
      api.get('/moduleViews' + '?' + qs.stringify(payload))
        .then(response => {
          commit('SET_MODULEVIEWS', response.data.results)
          commit('SET_MODULEVIEWSCONTEXT', response.data.page_context)
          store.commit('app/TOGGLE_LOADING', false)

          resolve(response.data)
        })
        .catch(err => {
          console.log('Error', err)
          // reject(err)
        })
    })

  },
  getModuleView ({ commit, state }, moduleViewId) {
    store.commit('app/ADD_LOADER')
    const { performApiCall } = useAPI()

    return new Promise((resolve, reject) => {
      let url = '/moduleViews/' + moduleViewId

      performApiCall(url, moduleViewId)
        .then(response => {
          store.commit('moduleView/UPDATE_MODULEVIEW', response)
          store.commit('app/REMOVE_LOADER')
          resolve(response)
        })
    })
  },
  async addModuleView ({ commit, state }, moduleView) {
    return await cleanEntityToSend(moduleView, state.params)
      .then(async clonedEntityToSend => {
        return new Promise((resolve, reject) => {
          api.post('/moduleViews', clonedEntityToSend)
            .then(response => {
              commit('ADD_MODULEVIEW', response.data)
              commit('UPDATE_MODULEVIEWSCONTEXTTOTALRESULT', 'add')

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The moduleView has been ', { crud: i18n.t('createdE') }),
                  variant: 'success'
                },
              })

              resolve(response)
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  async updateModuleView ({ commit, state }, moduleView) {
    delete moduleView.amount
    return await cleanEntityToSend(moduleView, state.params)
      .then(async clonedEntityToSend => {

        return new Promise((resolve, reject) => {
          api.put('/moduleViews/' + moduleView.id, clonedEntityToSend)
            .then(response => {
              commit('UPDATE_MODULEVIEW', response.data)
              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The moduleView has been ', { crud: i18n.t('editedE') }),
                  variant: 'success'
                },
              })

              resolve(response)
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  removeModuleView ({ commit }, moduleView) {
    return new Promise((resolve, reject) => {
      api.delete('/moduleViews/' + moduleView.id)
        .then(response => {
          commit('REMOVE_MODULEVIEW', moduleView)
          commit('UPDATE_MODULEVIEWSCONTEXTTOTALRESULT', 'sub')
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: capitalize(i18n.t('success')),
              icon: 'check',
              text: i18n.t('The moduleView has been ', { crud: i18n.t('removedE') }),
              variant: 'success'
            },
          })

          let userData = getUserData()
          userData.defaultViews[moduleView.module].id = response.data.id
          userData.defaultViews[moduleView.module].type = response.data.type
          localStorage.setItem('userData', JSON.stringify(userData))

          resolve(response)
        })
        .catch(error => {
          console.log('Error', error)
          reject(error)
        })
    })
  },
  getAutocompleteModuleViews ({ commit, state }, payload) {
    const { performApiCall } = useAPI()
    store.commit('app/TOGGLE_LOADING', true)

    return new Promise((resolve, reject) => {
      let url = '/autocomplete/moduleViews'

      performApiCall(url, payload)
        .then(response => {
          commit('SET_AUTOCOMPLETEMODULEVIEWS', response.results)
          store.commit('app/TOGGLE_LOADING', false)
          resolve(true)
        })
    })

  },
}